/**
 * Spacing shared by every card and panel (theme units: 1 = 8px), so pages
 * don't each pick their own. Corners, borders and shadows come from the theme.
 */

/** Inside a card or panel: 20px on phones, 24px wider. */
export const PANEL_PADDING = { xs: 2.5, md: 3 };

/** Rows inside a panel (lists, user rows) line up with the panel's content. */
export const PANEL_PADDING_X = PANEL_PADDING;

/** Above and below each row of a list: 14px. */
export const ROW_PADDING_Y = 1.75;

/**
 * For a table that fills its card edge to edge: the first and last columns
 * line up with the card's content, like list rows. Tables inside a padded
 * panel (chart data, import problems) keep the theme's 16px.
 */
export const FULL_BLEED_TABLE = {
  '& .MuiTableCell-root:first-of-type': { pl: PANEL_PADDING_X },
  '& .MuiTableCell-root:last-of-type': { pr: PANEL_PADDING_X },
};

/** Between stacked panels, and between cards in a grid: 24px. */
export const PANEL_GAP = 3;

/** Before a section heading that follows a panel: 32px. */
export const SECTION_GAP = 4;
